/* eslint-disable @typescript-eslint/camelcase */
import { useEffect, useReducer } from 'react';
import axios from 'axios';
import { LOADING_STARTS, LOADING_STOPS } from '../../../../../../../constants/types/shared/LoadingTypes';
import { GET_DATA } from '../../../../../../../constants/types/shared/CustomTypes';
import useForm from '../../../../../../../hooks/shared/custom/form/no-reload/useForm';
import nocSheetReducer from '../../../../../../../reducers/noc/shared/nocSheetReducer';
import { IP_ALLOCATION_URL } from '../api/IpAllocationUrl';

const useIpAllocation = (url) => {
  const [{ data, loading, pages }, dispatch] = useReducer(nocSheetReducer, {
    data: [],
    loading: false,
    pages: 0,
  });
  const { loadingForm, onChange, formValue, onSubmit, returned } = useForm(
    `${IP_ALLOCATION_URL}`,
    {
      ip_address: '',
      site: '',
      ip_allocation: '',
    },
    'IP Allocation',
  );
  const paginateChange = async (pagenumber) => {
    dispatch({
      type: LOADING_STARTS,
    });
    try {
      const response = await axios.get(`${url}/${pagenumber}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      });
      if (response.data.result) {
        dispatch({
          type: GET_DATA,
          payload: response.data.result,
        });
      } else {
        dispatch({ type: LOADING_STOPS });
      }
    } catch (e) {
      dispatch({ type: LOADING_STOPS });
    }
  };
  useEffect(() => {
    async function getData() {
      dispatch({
        type: LOADING_STARTS,
      });
      try {
        return await axios.get(`${url}/1`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          },
        });
      } catch (e) {
        return e;
      }
    }
    getData()
      .then((response) => {
        dispatch({
          type: GET_DATA,
          payload: response.data.result,
        });
      })
      .catch(() => dispatch({ type: LOADING_STOPS }));
    if (returned.data) {
      // dispatch({ type: REFETCH, payload: returned.data });
      getData()
        .then((response) => {
          dispatch({
            type: GET_DATA,
            payload: response.data.result,
          });
        })
        .catch(() => dispatch({ type: LOADING_STOPS }));
    }
  }, [returned.data, url]);
  return { data, loading, paginateChange, loadingForm, onChange, formValue, onSubmit, pages };
};

export default useIpAllocation;
